var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integration-status"},[_c('div',{staticClass:"integration-status__right"},[_c('VLabel',{attrs:{"type":_vm.status},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v("\n        "+_vm._s(_vm.$t(`companySettings.integrations.status.${_vm.status}`))+"\n      ")]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }